import store from "../store";
import { STATE_INITIAL, STATE_UPDATE } from "../store/slices";
import { DatabaseInstance } from "./databaseClass";

class UsStateClass {
  constructor() {}

  public getUsStates = async () => {
    store.dispatch(
      STATE_UPDATE({
        data: {
          ...STATE_INITIAL,
          isLoading: true,
        },
      }),
    );

    const data = {
      endpoint: "us-states/get-all",
    };

    const states = await DatabaseInstance.getRecord(data);

    if (!states) {
      store.dispatch(
        STATE_UPDATE({
          data: {
            states: [],
            isLoading: false,
            error: "Error fetching states",
          },
        }),
      );
      return;
    }

    store.dispatch(
      STATE_UPDATE({
        data: {
          states: states,
          isLoading: false,
          error: null,
        },
      }),
    );
  };
}

const UsStateInstance = new UsStateClass();

export { UsStateInstance };
